import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const formularioRespostaItemProcessoSlice = createSlice({
  name: 'formularioRespostaItemProcesso',
  initialState,
  reducers: {
    carregarFormularioRespostaItemProcesso: (state, action) => {
      const { idProcessoItem, resposta } = action.payload;
      state[idProcessoItem] = resposta;
    },
    limparFormularioRespostaItemProcesso: (state, action) => {
      delete state[action.payload];
    },
  },
});

export const {
  carregarFormularioRespostaItemProcesso,
  limparFormularioRespostaItemProcesso,
} = formularioRespostaItemProcessoSlice.actions;

export default formularioRespostaItemProcessoSlice.reducer;
